import { render, staticRenderFns } from "./Solicitante.vue?vue&type=template&id=2bce7d6c&scoped=true"
import script from "./Solicitante.vue?vue&type=script&lang=js"
export * from "./Solicitante.vue?vue&type=script&lang=js"
import style0 from "./Solicitante.vue?vue&type=style&index=0&id=2bce7d6c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bce7d6c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2bce7d6c')) {
      api.createRecord('2bce7d6c', component.options)
    } else {
      api.reload('2bce7d6c', component.options)
    }
    module.hot.accept("./Solicitante.vue?vue&type=template&id=2bce7d6c&scoped=true", function () {
      api.rerender('2bce7d6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/procesos/cotejo/infoBase/Solicitante.vue"
export default component.exports